// extracted by mini-css-extract-plugin
module.exports = {"row":"Category_row__YYJ9N"};